import MoneyDTO from "@/models/MoneyDTO";
import TraderRequisitesDTO from "@/models/TraderRequisitesDTO";
import {helper} from "@/service/CommonHelper";
import {numberFormatter} from "@/service/NumberFormatter";

export type RequisiteFillStatus = 'inactive' | 'limit' | 'near_limit' | 'in_progress' | 'free'

export const NEAR_LIMIT_RATIO = 0.9

const toNumber = (money?: MoneyDTO | null): number => {
    return money ? Number(money.amount) : 0
}

const ratio = (total: MoneyDTO, limit: MoneyDTO): number => {
    const max = toNumber(limit)

    return max > 0 ? toNumber(total) / max : 0
}

export type RequisiteBarStatus = 'inactive' | 'limit' | 'near_limit' | 'ok'

export const resolveBarStatus = (total: MoneyDTO, limit: MoneyDTO, isActive: boolean): RequisiteBarStatus => {
    if (isActive === false) {
        return 'inactive'
    }

    const filled = ratio(total, limit)

    if (filled >= 1) {
        return 'limit'
    }

    if (filled >= NEAR_LIMIT_RATIO) {
        return 'near_limit'
    }

    return 'ok'
}

export const hasFrozenSums = (item: TraderRequisitesDTO): boolean => {
    return item.dayTradesFrozenSum != null && item.monthTradesFrozenSum != null
}

export const splitSum = (total: MoneyDTO, frozen: MoneyDTO | null | undefined, limit: MoneyDTO) => {
    const totalValue = toNumber(total)
    const frozenValue = Math.min(toNumber(frozen), totalValue)
    const max = toNumber(limit)

    if (max <= 0) {
        return {confirmed: 0, frozen: 0, max: 1}
    }

    return {confirmed: totalValue - frozenValue, frozen: frozenValue, max}
}

export const resolveFillStatus = (item: TraderRequisitesDTO): RequisiteFillStatus => {
    if (item.isActive === false) {
        return 'inactive'
    }

    const filled = Math.max(
        ratio(item.dayTradesSum, item.dayTradesSumLimit),
        ratio(item.monthTradesSum, item.monthTradesSumLimit),
    )

    if (filled >= 1) {
        return 'limit'
    }

    if (filled >= NEAR_LIMIT_RATIO) {
        return 'near_limit'
    }

    if (toNumber(item.dayTradesFrozenSum) > 0 || toNumber(item.monthTradesFrozenSum) > 0) {
        return 'in_progress'
    }

    return 'free'
}

export const sumTitle = (labelKey: string, total: MoneyDTO, frozen?: MoneyDTO | null): string => {
    const label = helper.trans(labelKey)

    if (frozen == null) {
        return label
    }

    const frozenValue = Math.min(toNumber(frozen), toNumber(total))
    const confirmed = {...total, amount: String(toNumber(total) - frozenValue)}

    return `${label}: ${helper.trans('requisites.sum_confirmed')} ${numberFormatter.formatNumber(confirmed)}, ${helper.trans('requisites.sum_frozen')} ${numberFormatter.formatNumber(frozen)}`
}
